import { CanActivateFn } from '@angular/router';

export const hasUploadOrderPermissionGuard: CanActivateFn = (route, state) => {

  const userDetails = JSON.parse(localStorage.getItem('currentUser'));

  if(userDetails && userDetails.is_upload_order){

    return true;

  }

  return false

};
